export default "__VITE_ASSET__84cdf880__"